import {setup} from '../../snippets/python';
import comment from '../../snippets/comment';
import {CreateShellCommand} from '../../../components/left-col';

export const steps = {
  setup,
  price: {},
  create: {},
  'payment-methods': {},
  'line-items': {},
  mode: {},
  redirect: {},
  urls: {},
  portal: {},
  'run-server': {
    Component: CreateShellCommand('python3 -m flask run --port=4242'),
  },
};

export default ({keys, merchant, client}) => `#! /usr/bin/env python3.6

"""
server.py
Stripe Sample.
Python 3.6 or newer required.
"""
import os
from flask import Flask, redirect, jsonify, json, request, current_app

{+setup}
import stripe
${comment && comment(merchant, '#')}
stripe.api_key = '${keys.secret}'
{/setup}

app = Flask(__name__,
            static_url_path='',
            static_folder='public')

YOUR_DOMAIN = '${
  client === 'react'
    ? 'http://localhost:3000/checkout'
    : 'http://localhost:4242'
}'

@app.route('/', methods=['GET'])
def get_index():
    return current_app.send_static_file('index.html')

@app.route('/create-checkout-session', methods=['POST'])
def create_checkout_session():
    {+create}
    try:
        {+price}
        prices = stripe.Price.list(
            lookup_keys=[request.form['lookup_key']],
            expand=['data.product']
        )
        {/price}

        {span response create}checkout_session{/span} = stripe.checkout.Session.create(
            {+payment-methods}
            payment_method_types=['card'],
            {/payment-methods}
            {+line-items}
            line_items=[
                {
                    'price': prices.data[0].id,
                    'quantity': 1,
                },
            ],
            {/line-items}
            {+mode}
            mode='subscription',
            {/mode}
            {+urls}
            success_url=YOUR_DOMAIN +
            '/success.html?session_id={CHECKOUT_SESSION_ID}',
            cancel_url=YOUR_DOMAIN + '/cancel.html',
            {/urls}
            {?add-trial trial-period-days}
            subscription_data={
                'trial_period_days': 7
            },
            {/trial-period-days}
            {?add-discount discounts}
            discounts=[
                {
                    'coupon': '{{COUPON_ID}}'
                }
            ],
            {/discounts}
            {?add-customer customer}
            customer='cus_123',
            {/customer}
            {?automatic-tax automatic-tax-param}
            automatic_tax={
              'enabled': True
            },
            {/automatic-tax-param}
        )
        {/create}
        {+redirect}
        return redirect(checkout_session.url, code=303)
        {/redirect}
    except Exception as e:
        print(e)
        return "Server error", 500

@app.route('/create-portal-session', methods=['POST'])
def customer_portal():
    # For demonstration purposes, we're using the Checkout session to retrieve the customer ID.
    # Typically this is stored alongside the authenticated user in your database.
    checkout_session_id = request.form.get('session_id')
    checkout_session = stripe.checkout.Session.retrieve(checkout_session_id)

    # This is the URL to which the customer will be redirected after they are
    # done managing their billing with the portal.
    return_url = YOUR_DOMAIN

    {+portal}
    portalSession = stripe.billing_portal.Session.create(
        customer=checkout_session.customer,
        return_url=return_url,
    )
    {/portal}
    {+portal-redirect}
    return redirect(portalSession.url, code=303)
    {/portal-redirect}

{+provision-access-webhooks}
@app.route('/webhook', methods=['POST'])
def webhook_received():
    # Replace this endpoint secret with your endpoint's unique secret
    # If you are testing with the CLI, find the secret by running 'stripe listen'
    # If you are using an endpoint defined with the API or dashboard, look in your webhook settings
    # at https://dashboard.stripe.com/webhooks
    webhook_secret = 'whsec_12345'
    request_data = json.loads(request.data)

    if webhook_secret:
        # Retrieve the event by verifying the signature using the raw body and secret if webhook signing is configured.
        signature = request.headers.get('stripe-signature')
        try:
            event = stripe.Webhook.construct_event(
                payload=request.data, sig_header=signature, secret=webhook_secret)
            data = event['data']
        except Exception as e:
            return e
        # Get the type of webhook event sent - used to check the status of PaymentIntents.
        event_type = event['type']
    else:
        data = request_data['data']
        event_type = request_data['type']
    data_object = data['object']

    print('event ' + event_type)

    if event_type == 'checkout.session.completed':
        print('🔔 Payment succeeded!')
    elif event_type == 'customer.subscription.trial_will_end':
        print('Subscription trial will end')
    elif event_type == 'customer.subscription.created':
        print('Subscription created %s', event.id)
    elif event_type == 'customer.subscription.updated':
        print('Subscription created %s', event.id)
    elif event_type == 'customer.subscription.deleted':
        # handle subscription cancelled automatically based
        # upon your subscription settings. Or if the user cancels it.
        print('Subscription canceled: %s', event.id)

    return jsonify({'status': 'success'})
{/provision-access-webhooks}


if __name__ == '__main__':
    app.run(port=4242)
`;
